import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { FiTrash2, FiEdit2, FiChevronDown, FiChevronUp } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import DestinationDetails from './DestinationDetails';
import EditDestination from './EditDestination'; 

const ToggleButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 0.5rem;
`;

const Container = styled.div`
  padding: 4rem 2rem;
  margin-bottom: 100px;

 
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  h2 {
    color: #385963;
  }

  button {
    background-color: #385963;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    cursor: pointer;
    font-size: 0.9rem;
  }

  button:hover {
    background-color: #2c4a52;
  }

   @media (max-width: 768px) {
   h2{
     font-size: 13px;
   }

   button{
      font-size: 10px;
   }

  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  box-shadow: 0 4px 10px rgba(0,0,0,0.05);

  th, td {
    padding: 1rem;
    text-align: left;
    border-bottom: 1px solid #eee;
    color: #385963;
  }

  th {
    background-color: #f9f9f9;
  }

  td:last-child {
    text-align: right;
  }

  button {
    background: none;
    border: none;
    color: #e74c3c;
    cursor: pointer;
    font-size: 1.2rem;
  }

  button:hover {
    color: #c0392b;
  }
`;

const SearchBar = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 0.5rem 1rem;
  

  input {
    border: none;
    flex: 1;
    font-size: 1rem;
    outline: none;
    color:#385963;
  }

  svg {
    margin-right: 0.5rem;
    color: #555;
  }
`;



const ManageDestinations = () => {

const BASE_URL = process.env.REACT_APP_BASE_URL;
const { i18n, t } = useTranslation();
const tokenString = sessionStorage.getItem("token");
const rawLang = i18n.language;
const language = rawLang.startsWith('gr') ? 'gr' : 'en';
const otherLang = language === 'gr' ? 'en' : 'gr';
const navigate = useNavigate();
const [destinations, setDestinations] = useState([]);
const [expandedRow, setExpandedRow] = useState(null);
const [searchTerm, setSearchTerm] = useState('');



useEffect(() => {
  const fetchDestinations = async () => {
    try {
      const response = await fetch(`${BASE_URL}Destination`);
      const data = await response.json();  // <-- THIS is the actual destination array
      setDestinations(data);
    } catch (error) {
      console.error('Error fetching destinations:', error);
    }
  };

  fetchDestinations();
}, []);


const handleDelete = (id) => {
  if (!window.confirm(t('confirmDelete'))) return;

  // Define the function FIRST
  const deleteDestination = async () => {
    try {
      const response = await fetch(`${BASE_URL}Destination/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${tokenString}`
        }
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        console.error("Error response:", errorMessage);
        throw new Error(`Failed to delete destination: ${errorMessage}`);
      }
      // Remove the destination from state only if deletion succeeded
      setDestinations(prev => prev.filter(d => d.id !== id));

    } catch (error) {
      console.error('Error deleting destination:', error);
      alert(t('errorDeletingDestination') || "Cannot delete this destination. It may be in use.");
    }
  };
  deleteDestination();
};

const filteredDestinations = Array.isArray(destinations)
  ? destinations.filter((destination) => {
      const name1 = destination?.name?.[language]?.toLowerCase() || '';
      const name2 = destination?.name?.[otherLang]?.toLowerCase() || '';
      const term = searchTerm.toLowerCase();
      return name1.includes(term) || name2.includes(term);
    })
  : [];


const [editingDestination, setEditingDestination] = useState(null);  

  const handleEdit = (destination) => {
    // Open the Edit Form with the selected destination details
    setEditingDestination(destination);
  };

  return (
    <Container>
      <Header>
        <h2>{t('manageDestinations')}</h2>
        <button onClick={() => navigate('/admin/add-destination')}>
          + {t('addDestination')}
        </button>
      </Header>

       <SearchBar>
            <FiSearch />
            <input
              type="text"
              placeholder={i18n.t('searchByName')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </SearchBar>

      <Table>
        <thead>
          <tr>
            <th>{t('name')}</th>
            <th>{t('actions')}</th>
          </tr>
        </thead>
        <tbody>
          {filteredDestinations.map((dest) => (
            <React.Fragment key={dest.id}>
              <tr>
                {/* <td>{dest.name[language]}</td> */}
                <td>
                  {dest.name[language]}{' '}
                  <span style={{ color: '#888' }}>
                    ({dest.name[otherLang]})
                  </span>
                </td>
                <td style={{ textAlign: 'right' }}>
                  <ToggleButton onClick={() => setExpandedRow(expandedRow === dest.id ? null : dest.id)}>
                    {expandedRow === dest.id ? <FiChevronUp /> : <FiChevronDown />}
                  </ToggleButton>
                  <ToggleButton onClick={() => navigate(`/admin/edit-destination/${dest.id}`)}>
                    <FiEdit2 />
                  </ToggleButton>
                  <ToggleButton onClick={() => handleDelete(dest.id)}>
                    <FiTrash2 />
                  </ToggleButton>
                </td>
              </tr>
              {expandedRow === dest.id && (
                <tr>
                  <td colSpan="2">
                    <DestinationDetails destination={dest}  />
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </Table>

    </Container>
  );
};

export default ManageDestinations;

